'use strict';
import {storage} from '../../config/constants';

FileUrlCache.$inject = [
  '$cacheFactory',
];

export function FileUrlCache(
  $cacheFactory,
) {
  // var self = this;
  const cache = $cacheFactory.get('FileUrlCache') || $cacheFactory('FileUrlCache', {capacity: 100}); // eject somewhat eagerly so the file data can be released
  let session = storage.get('session'); // protects against disconnected uploads like app restarts or page refreshes
  if (!session && session !== 0) {
    session = 0;
    storage.set('session', session);
  } else {
    storage.set('session', ++session);
  }

  this.has = has;
  this.get = get;
  this.put = put;
  this.remove = cache.remove.bind(cache);
  this.removeAll = cache.removeAll.bind(cache);
  this.destroy = cache.destroy.bind(cache);

  function has(key) {
    const result = cache.get(key);
    return result && result.session == session;
  }

  function get(key) {
    const result = cache.get(key);
    return result && result.session == session ? result : null;
  }

  function put(key, file) {
    if (!file) return;
    file.session = session;
    return cache.put(key, file);
  }
}



// WEBPACK FOOTER //
// ./src/js/files/services/FileUrlCache.js